import { Button, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";
import { useEffect, useState } from "react";

type MenuProps = {
  field: any;
  placeholder: string;
  items: Array<string>;
  setValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

export const QuestionComponent = ({ field, placeholder, items, setValue }: MenuProps) => {
  const [selectedItem, setSelectedItem] = useState(field.value || "");

  useEffect(() => {
    setSelectedItem(field.value || "");
  }, [field.value]);

  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        rightIcon={<Icon name="arrow-down-1" size="sm" />}
        textColor={selectedItem ? "foreground.primary" : "foreground.secondary"}
        border="1px solid"
        borderColor="border.secondary"
        textAlign="left"
        p={"spacing-sm"}
        fontWeight="400"
      >
        {selectedItem || placeholder}
      </MenuButton>
      <MenuList>
        {items.map((item) => (
          <MenuItem
            key={item}
            onClick={() => {
              setValue(field.name, item);
              setSelectedItem(item);
              return;
            }}
          >
            {item}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
